'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WIZARD_CONTAINER_ID = exports.WIZARD_CONTAINER_ID = '__ultimate-ui-wizard-content';

exports.default = WIZARD_CONTAINER_ID;